export const ids = ['system', 'config', 'custom', 'virtual'] as const;
